import type { SegmentCheck } from "@/interfaces/selections/selections.types";

/**
 * Maps usable segment checks to the codes this caller can actually select.
 * An ALREADY_HAVE match is by fingerprint, so the shared `code` belongs to the
 * sender and `existingCode` is the caller's own equivalent — selecting the
 * former would reference a segment the caller does not have.
 */
export function resolveOwnedSegmentCodes(usableSegments: SegmentCheck[]): string[] {
  return Array.from(new Set(usableSegments.map((c) => c.existingCode ?? c.code)));
}
